import { render, staticRenderFns } from "./FamiliaresComponent.vue?vue&type=template&id=39ada543"
import script from "./FamiliaresComponent.vue?vue&type=script&lang=js"
export * from "./FamiliaresComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports